import "./Home.css"
import logo from "../../assets/logo.png"
import {Link} from "react-router-dom";
import img1 from "../../assets/home-img/Rectangle 1 - home 5.png"
import img2 from "../../assets/home-img/Rectangle 1 full home 5.png"
import img3 from "../../assets/home-img/Rectangle 2 full- home 5.png"
import img4 from "../../assets/home-img/Rectangle 2 home 5.png"
import video from "../../assets/video/video (720p).mp4"
import {useState, useRef, useEffect} from "react";
import Loading from "../UI/Loading/Loading";

const Home = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [isImgLabVisible, setIsImgLabVisible] = useState(false)
    const [isImgStuVisible, setIsImgStuVisible] = useState(false)
    const [transform, setTransform] = useState(null)
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    };
    const handleHover = (val) => {
        if (val === "lab") {
            setIsImgLabVisible(true)
            setTransform("translateX(-40px)")
        } else if (val === "stu") {
            setTransform("translateX(40px)")
            setIsImgStuVisible(true)
        }

    };
    const textRef = useRef(null)
    const handleMouseLeave = (val) => {
        setTransform(null)

        if (val === "lab") {
            setIsImgLabVisible(false)
        } else if (val === "stu") {
            setIsImgStuVisible(false)
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => {
            clearTimeout(loadingTimeout);
        };
    }, [])

    return (
        <>
            {isLoading && <Loading/>}
            <div className="home-container">
                <div className={"home"}>
                    <ul className="home-dots">
                        <li onClick={() => scrollToSection('first')}>
                            <div>.</div>
                            <p>01</p>
                        </li>
                        <li onClick={() => scrollToSection('second')}>
                            <div>.</div>
                            <p>02</p>
                        </li>
                        <li onClick={() => scrollToSection('third')}>
                            <div>.</div>
                            <p>03</p>
                        </li>
                        <li onClick={() => scrollToSection('fourth')}>
                            <div>.</div>
                            <p>04</p>
                        </li>
                        <li onClick={() => scrollToSection('fifth')}>
                            <div>.</div>
                            <p>05</p>
                        </li>
                    </ul>
                    <div className="home-first-container" ref={textRef} id={"first"}>
                        <video autoPlay muted loop playsInline>
                            <source src={video} type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>
                        <div className="home-first">
                            <h1 className={"textHeightAnimation"}>
                                let's make an impact
                            </h1>
                            <div className={"textHeightAnimation"}>
                                We are a forward-looking holding company focused on building products and solutions that
                                are
                                needed for today’s complex world.
                            </div>
                        </div>
                    </div>
                    <div className="home-second-container" id={"second"}>
                        <div className="home-second">
                            <img src={logo} alt=""/>
                            <div className={"home-number"}>
                                <p>02</p>
                                <p>Introduction to Arnikup</p>
                            </div>
                            <h1 className={"home-h1"}>
                                Arnikup is a multi-faceted enabler Digital Solutions Holding providing tailor-made
                                digital
                                and
                                business solutions across a wide spectrum of industries.
                            </h1>
                        </div>
                    </div>
                    <div className="home-third-container" id={"third"}>
                        <div className="home-third">
                            <img src={logo} alt=""/>
                            <div className={"home-number"}>
                                <p>03</p>
                                <p>Introduction to Arnikup</p>
                            </div>
                            <h1 className={"home-h1"}>
                                Our philosophy,
                                vision and goals
                            </h1>
                            <div className={"home-third-div"}>
                                Remain our client’s first choice by exceeding their expectations. Our client’s cannot
                                simply
                                be satisfied with our services, they must be impressed.
                                Strive to be best in class and intercept technological developments which could improve
                                our
                                services.
                            </div>
                        </div>
                    </div>
                    <div className="home-fourth-container" id={"fourth"}>
                        <div className="home-fourth">
                            <img src={logo} alt=""/>
                            <div className={"home-number"}>
                                <p>04</p>
                                <p>Introduction to Arnikup</p>
                            </div>
                            <h1 className={"home-h1"}>
                                Our operations and projects span Europe and the Middle East covering multiple
                                industries.
                            </h1>
                            <div className={"home-third-div"}>
                                As an international Consulting and Information Technology company, we pride ourselves in
                                designing and delivering tailor-made solutions and tools which our clients can utilise
                                to
                                further their business interests.
                            </div>
                        </div>
                    </div>

                    <div className="home-fifth-container" id={"fifth"}>
                        <div className="home-fifth">
                            <img className="home-img img1" src={img1}
                                 style={{transform: transform ? transform : "translateX(0px)"}} alt=""/>
                            <img className="home-img img2" src={img2} alt="" style={{
                                opacity: isImgLabVisible ? 1 : 0,
                                transform: transform ? transform : "translateX(0px)"
                            }}/>
                            <img className="home-img img3" src={img3} alt="" style={{
                                opacity: isImgStuVisible ? 1 : 0,
                                transform: transform ? transform : "translateX(0px)"
                            }}/>
                            <img className="home-img img4" src={img4} alt=""
                                 style={{transform: transform ? transform : "translateX(0px)"}}/>
                            <img src={logo} alt=""/>
                            <div className={"fifth-number-container"}>
                                <div className={"home-number"}>
                                    <p>05</p>
                                    <p>Learn more about our</p>
                                </div>
                                <div className={"fifth-h1-container"}>
                                    <div>
                                        <h1 onMouseEnter={() => handleHover("lab")}
                                            onMouseLeave={() => handleMouseLeave("lab")}>
                                            <Link to={"/laboratory"}>
                                                ARNIKA LABORATORY
                                            </Link>
                                        </h1>
                                        <p>Make the Right Decision.</p>
                                    </div>
                                    <div>
                                        <h1 onMouseEnter={() => handleHover("stu")}
                                            onMouseLeave={() => handleMouseLeave("stu")}>
                                            <Link to={"/studio"}>
                                                ARNIKA STUDIO
                                            </Link>
                                        </h1>
                                        <p>World-class support and mentorship</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Home;